module.exports = __webpack_public_path__ + "static/calorex-header-greenfoam-mb-5c5eaa15ef969ecdf6b8bb34d884b1fd.jpg";